import { Component, computed, EventEmitter, HostListener, inject, Input, OnInit, Output, signal } from '@angular/core';
import { Helperclass } from '../../class/helperclass';
import { UtilityService } from '../../services/utility.service';
import { CatalogsService } from '../../services/catalogs.service';
import { UiFeedbackService } from '@app/core/services/ui-feedback.service';

@Component({
  selector: 'motor-calculo-head',
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss']
})
export class HeadComponent implements OnInit {
  @Input() isLogin = true;
  @Output() output = new EventEmitter<boolean>();
  @Output() openMenu = new EventEmitter<boolean>();

  readonly #uiFeedback = inject(UiFeedbackService);

  readonly #dataMotor = JSON.parse(sessionStorage.getItem('dataMotor') || '{}') || '';
  readonly #agenteID = sessionStorage.getItem('agentID') || '';

  showToolbar = computed(() => this.#uiFeedback.showToolbal());
  perfil = signal('');
  agenteID = signal('');

  @HostListener('document:click', ['$event'])
  handleClick($event: PointerEvent) {
    const target = $event.target as HTMLElement;
    const isPerfil = target.closest('.perfil');

    if (!isPerfil && this.showToolbar()) {
      this.closeToolbar();
    }
  }


  constructor(
    private Helperclass: Helperclass,
    private UtilityService: UtilityService,
    private CatalogsService: CatalogsService
  ) {
    this.UtilityService.IsLogin$.subscribe(data => this.isLogin = data);
    this.buscarConExpiracion();
    this.UtilityService.IsCatalog$.subscribe(data => {
      if (data) {
        this.cargacatalogos();
      }
    })
  }

  ngOnInit(): void {
    this.perfil.set(this.#dataMotor?.perfil || '');
    this.agenteID.set(this.#agenteID);
  }

  /**
   * Eliminar cuando se implemente el JWT
   */
  buscarConExpiracion(): void {
    this.isLogin = true;
    this.cargacatalogos();
    // if (sessionStorage.getItem('expirationMotor')) {
    //   let data = sessionStorage.getItem('expirationMotor');
    //   data = JSON.parse(data || '{}');

    //   if (data) {
    //     // Obtener la hora actual en la zona horaria de la Ciudad de México
    //     const fecha: Date = new Date();
    //     const fechaExpiracion: Date = new Date(data);

    //     if (fecha.getTime() - fechaExpiracion.getTime() > 60 * 60 * 1000) { // una hora en milisegundos
    //       this.isLogin = false;
    //       sessionStorage.removeItem('tokenMotor');
    //       sessionStorage.removeItem('expirationMotor');
    //       sessionStorage.removeItem('dataMotor');
    //       sessionStorage.removeItem('Idusuario');
    //       this.Helperclass.goRouter('/');
    //     } else {
    //       this.isLogin = true;
    //       this.cargacatalogos();
    //     }
    //   }
    // } else {
    //   this.UtilityService.IsLogin$.next(false);
    //   this.Helperclass.goRouter('/');
    // }
  }

  setShowToolbar() {
    this.#uiFeedback.setShowToolbar(!this.showToolbar());
  }

  closeToolbar() {
    this.#uiFeedback.setShowToolbar(false);
  }

  async exit() {
    try {
      const response = await this.Helperclass.showalert('¡Atención!', '¿Seguro que quiere salir?');
      if (response.isConfirmed) {
        this.UtilityService.IsLogin$.next(false);
        sessionStorage.clear();
        this.isLogin = false;
        this.output.emit(false);
        window.location.reload();
      }
    } catch (error) {

    }
  }

  openChangePassword() {
    this.#uiFeedback.configurateResetPasswordModal({ visible: true, showCancelButton: true, cancelButtonText: 'Cerrar' });
  }

  async cargacatalogos() {
    this.UtilityService.IsSpinner$.next(true);
    await this.CatalogsService.setCatalogos();
    this.UtilityService.IsSpinner$.next(false);
  }

  openmenu() {
    this.openMenu.emit(true);
  }
}
